import { type FieldPathByValue } from 'react-hook-form';

type NestedDictionary = {
  [x: string]: string | NestedDictionary;
};

type FlatDictionaryKey<T extends NestedDictionary> = FieldPathByValue<
  T,
  string
>;
type FlatDictionary<T extends NestedDictionary> = Record<
  FlatDictionaryKey<T>,
  string
>;

export const flattenMessages = <T extends NestedDictionary>(
  nestedMessages: T,
  prefix = '',
): FlatDictionary<T> =>
  Object.entries(nestedMessages).reduce((messages, [key, value]) => {
    const prefixedKey = prefix !== '' ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      messages[prefixedKey as FlatDictionaryKey<T>] = value;
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }

    return messages;
  }, {} as FlatDictionary<T>);

export default flattenMessages;
